<script setup lang="ts">
  import FlowCardQC from '@/shared/components/FlowCardQC/FlowCardQC.vue'
  import WrapperQC from '@qicgroupdoha/qic-connect-ds/components/WrapperQC'
  import IconQC from '@qicgroupdoha/qic-connect-ds/components/IconQC'

  const COVER_POINT_KEYS = [
    'travel.quote.inclusive_cover.ooredoo.point1.text',
    'travel.quote.inclusive_cover.ooredoo.point2.text',
    'travel.quote.inclusive_cover.ooredoo.point3.text',
  ]
</script>

<template>
  <FlowCardQC class="quote-coverage-ooredoo-qc" data-test="quote-coverage-ooredoo">
    <WrapperQC direction="column" gap="var(--spacing-5)">
      <h2 class="heading-5">{{ $t('travel.common.quote.inclusive_cover.name') }}</h2>

      <WrapperQC direction="column">
        <WrapperQC
          v-for="pointKey in COVER_POINT_KEYS"
          :key="pointKey"
          gap="var(--spacing-2)"
          class="quote-coverage-ooredoo-qc__item"
          data-test="quote-coverage-ooredoo-item"
        >
          <IconQC name="check" color="var(--colorIcnSrfAction)" />
          <p class="text-medium">{{ $t(pointKey) }}</p>
        </WrapperQC>
      </WrapperQC>
    </WrapperQC>
  </FlowCardQC>
</template>

<style scoped lang="scss">
  @use '@/shared/assets/styles/mixins';

  .quote-coverage-ooredoo-qc {
    @include mixins.mobile-flow {
      padding-block: var(--spacing-8);
    }
  }

  .quote-coverage-ooredoo-qc__item {
    align-items: center;
    padding-block: 2px;
  }
</style>
